import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import LockIcon from '@/public/icons/approval/lock.svg';

const LockSlot = styled('span', {
  shouldForwardProp: (prop) => prop !== '$compact',
})<{ $compact?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ $compact }) => ($compact ? 18 : 24)}px;
  height: ${({ $compact }) => ($compact ? 18 : 24)}px;
  color: var(--dk-text-secondary, #888d96);
`;

type Props = {
  /** 'referrer' 참조인 / 'approver' 결재자 / 'coApprover' 협조결재자 — 툴팁 문구만 다름 */
  target: 'referrer' | 'approver' | 'coApprover';
  /** 참조인 칩처럼 자리가 좁은 곳에서 쓰는 작은 크기 */
  compact?: boolean;
};

/**
 * 어드민이 양식에 고정해 둔 결재자/협조자/참조인임을 알리는 자물쇠 표시.
 * 삭제 버튼(X) 자리를 그대로 대신 차지해 '지울 수 없는 항목'임을 그 자리에서 보여준다.
 * 작성 참조인 칩 / 작성 결재라인 행 공용 — 문구 스펙 단일 지점.
 */
const FixedMemberLock = ({ target, compact = false }: Props) => {
  const { t } = useTranslation();
  const label = {
    referrer: t('양식에 고정된 참조인이라 삭제할 수 없어요.'),
    approver: t('양식에 고정된 결재자라 삭제할 수 없어요.'),
    coApprover: t('양식에 고정된 협조결재자라 삭제할 수 없어요.'),
  }[target];
  // lock.svg 는 24 viewBox 안에서 자물쇠가 절반 남짓만 차지해, 같은 px 값이어도
  // close.svg(16 viewBox 를 거의 채움)보다 훨씬 작아 보인다. 그만큼 키워서 맞춘다.
  const iconSize = compact ? 18 : 22;

  return (
    <LockSlot $compact={compact} title={label} aria-label={label}>
      <LockIcon
        width={iconSize}
        height={iconSize}
        style={{ ['--icon-stroke-width' as string]: 1.5 }}
      />
    </LockSlot>
  );
};

export default FixedMemberLock;
